import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router";


const MetaData = ({ meta, noindex, children, skipDefault, isDashboard }) => {

	let notifications = useSelector(({ auth: { notifications } }) => notifications ? (notifications.length ? notifications : null) : null)
	let { pathname } = useLocation();
	let [title, setTitle] = useState();

	useEffect(() => {
		if(meta && meta.title) {
			setTitle(notifications ? `(${notifications.length}) ${meta.title}` : meta.title)
		} else {
			setTitle(notifications ? `(${notifications.length}) ${document.title.replace(/ *\([^)]*\) */g, "")}` : document.title)
		}
	}, [ notifications, pathname ]);

	if (meta) {

		let { description, image, canonical, title: metaTitle } = meta;

		return <>

			{isDashboard ?
				<Helmet titleTemplate={skipDefault ? '' : '%s | Paylix'}>
					<title>{title || metaTitle}</title>
					<meta name="robots" content="noindex" />
				</Helmet> :

				<Helmet titleTemplate={skipDefault ? '' : '%s | Paylix'}>
					<title>{title || metaTitle}</title>
					<meta name="description" content={description || 'Paylix Dashboard'}/>
					{canonical ? <link rel="canonical" href={canonical} /> : null}

					<meta property="og:title" content={title || metaTitle || 'Dashboard'}/>
					<meta property="og:description" content={description || 'Paylix Dashboard'}/>
					<meta property="og:image" content={image ? image : 'https://cdn.paylix.gg/static/logo/single-less-border.png'} />
					<meta property="og:image" content={image ? image : 'https://cdn.paylix.gg/static/logo/single-less-border.png'} />
					<meta property="og:image:width" content="500" />
					<meta property="og:image:height" content="300" />

					<meta property="twitter:title" content={title || metaTitle || 'Dashboard'} />
					<meta property="twitter:description" content={description || 'Paylix Dashboard'} />
					<meta property="twitter:image" content={image ? image : 'https://cdn.paylix.gg/static/logo/single-less-border.png'} />
					<meta property="twitter:card" content={image ? 'summary_large_image' : 'summary'} />

					<meta name="twitter:title" content={title || metaTitle || 'Dashboard'} />
					<meta name="twitter:description" content={description || 'Paylix Dashboard'} />

					{noindex ? <meta name="robots" content="noindex" /> : null}
				</Helmet>
			}

			<>{children}</>
		</>
	}

	return <>
		{children}
	</>
}

export default MetaData;



